{{#if (equal resultMessage 'deposit/success')}}
<p><strong>포커칩 10만칩이 정상적으로 입금 되었습니다.</strong></p>
<p class="blank"></p>
{{/if}}

{{#if (equal resultMessage 'deposit/not-allowed')}}
<p><strong>포커칩이 입금되지 않았습니다.</strong></p>
<p><em>※ 소지한 포커칩이 11만칩 이상일 경우 입금이 가능합니다.</em></p>
{{/if}}

{{#if (equal resultMessage 'deposit/fail')}}
<p><strong>포커칩 입금에 실패했습니다.</strong></p>
<p><em>※ 잠시 후 다시 시도해 주십시오.</em></p>
{{/if}}

{{#if (equal resultMessage 'withdraw/success')}}
<p><strong>포커칩 10만칩이 정상적으로 출금 되었습니다.</strong></p>
<p class="blank"></p>
{{/if}}

{{#if (equal resultMessage 'withdraw/not-allowed')}}
<p><strong>포커칩이 출금되지 않았습니다.</strong></p>
<p><em>※ 소지한 포커칩이 10만칩 미만일 경우 출금이 가능합니다.</em></p>
{{/if}}

{{#if (equal resultMessage 'withdraw/fail')}}
<p><strong>포커칩 출금에 실패했습니다.</strong></p>
<p><em>※ 잠시 후 다시 시도해 주십시오.</em></p>
{{/if}}